<button class="like-button" (click)="likeButtonClick()" [ngClass]="{ light: (1 | colourTheme) === false }">
    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.294 15.5319C9.60492 16.1575 8.54411 16.1575 7.85504 15.5229L7.7553 15.4322C2.99526 11.1255 -0.11463 8.30573 0.00323778 4.78783C0.0576382 3.24649 0.846445 1.76861 2.12486 0.8982C4.51848 -0.733813 7.47423 0.0277934 9.06998 1.89554C10.6657 0.0277934 13.6215 -0.74288 16.0151 0.8982C17.2935 1.76861 18.0823 3.24649 18.1367 4.78783C18.2637 8.30573 15.1447 11.1255 10.3847 15.4503L10.294 15.5319Z"
            fill="#F2F2F2"
        />
    </svg>
</button>
